"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createStyles = _interopRequireDefault(require("../utils/createStyles"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default = theme => _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
  card: {
    boxSizing: 'border-box',
    overflowY: 'auto',
    overflowX: 'hidden',
    borderStyle: 'solid',
    borderColor: theme.palette.accent
  }
}, (0, _createStyles.default)('backgroundColor', theme.palette)), (0, _createStyles.default)('borderRadius', theme.borderRadius)), (0, _createStyles.default)('borderWidth', theme.borderWidth)), (0, _createStyles.default)('boxShadow', {
  light: '0 4px 8px rgba(57, 63, 70, 0.1)',
  intense: '0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2)',
  // eslint-disable-line max-len
  none: 'none'
})), {}, {
  fullWidth: {
    width: '100%'
  },
  fullHeight: {
    height: '100%'
  }
});

exports.default = _default;